import { CountryInfo } from 'types/common'

export const countries: Record<string, CountryInfo> = {
  BD: {
    country: 'Bangladesh',
    countryCode: 'BD',
    currencyCode: 'BDT',
    phoneCode: '880',
  },
  BE: {
    country: 'Belgium',
    countryCode: 'BE',
    currencyCode: 'EUR',
    phoneCode: '32',
  },
  BF: {
    country: 'Burkina Faso',
    countryCode: 'BF',
    currencyCode: 'XOF',
    phoneCode: '226',
  },
  BG: {
    country: 'Bulgaria',
    countryCode: 'BG',
    currencyCode: 'BGN',
    phoneCode: '359',
  },
  BA: {
    country: 'Bosnia and Herzegovina',
    countryCode: 'BA',
    currencyCode: 'BAM',
    phoneCode: '387',
  },
  BB: {
    country: 'Barbados',
    countryCode: 'BB',
    currencyCode: 'BBD',
    phoneCode: '1-246',
  },
  WF: {
    country: 'Wallis and Futuna',
    countryCode: 'WF',
    currencyCode: 'XPF',
    phoneCode: '681',
  },
  BL: {
    country: 'Saint Barthelemy',
    countryCode: 'BL',
    currencyCode: 'EUR',
    phoneCode: '590',
  },
  BM: {
    country: 'Bermuda',
    countryCode: 'BM',
    currencyCode: 'BMD',
    phoneCode: '1-441',
  },
  BN: {
    country: 'Brunei',
    countryCode: 'BN',
    currencyCode: 'BND',
    phoneCode: '673',
  },
  BO: {
    country: 'Bolivia',
    countryCode: 'BO',
    currencyCode: 'BOB',
    phoneCode: '591',
  },
  BH: {
    country: 'Bahrain',
    countryCode: 'BH',
    currencyCode: 'BHD',
    phoneCode: '973',
  },
  BI: {
    country: 'Burundi',
    countryCode: 'BI',
    currencyCode: 'BIF',
    phoneCode: '257',
  },
  BJ: {
    country: 'Benin',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    phoneCode: '229',
  },
  BT: {
    country: 'Bhutan',
    countryCode: 'BT',
    currencyCode: 'BTN',
    phoneCode: '975',
  },
  JM: {
    country: 'Jamaica',
    countryCode: 'JM',
    currencyCode: 'JMD',
    phoneCode: '1-876',
  },
  BV: {
    country: 'Bouvet Island',
    countryCode: 'BV',
    currencyCode: 'NOK',
    phoneCode: '',
  },
  BW: {
    country: 'Botswana',
    countryCode: 'BW',
    currencyCode: 'BWP',
    phoneCode: '267',
  },
  WS: {
    country: 'Samoa',
    countryCode: 'WS',
    currencyCode: 'WST',
    phoneCode: '685',
  },
  BQ: {
    country: 'Bonaire, Saint Eustatius and Saba ',
    countryCode: 'BQ',
    currencyCode: 'USD',
    phoneCode: '599',
  },
  BR: {
    country: 'Brazil',
    countryCode: 'BR',
    currencyCode: 'BRL',
    phoneCode: '55',
  },
  BS: {
    country: 'Bahamas',
    countryCode: 'BS',
    currencyCode: 'BSD',
    phoneCode: '1-242',
  },
  JE: {
    country: 'Jersey',
    countryCode: 'JE',
    currencyCode: 'GBP',
    phoneCode: '44-1534',
  },
  BY: {
    country: 'Belarus',
    countryCode: 'BY',
    currencyCode: 'BYN',
    phoneCode: '375',
  },
  BZ: {
    country: 'Belize',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    phoneCode: '501',
  },
  RU: {
    country: 'Russia',
    countryCode: 'RU',
    currencyCode: 'RUB',
    phoneCode: '7',
  },
  RW: {
    country: 'Rwanda',
    countryCode: 'RW',
    currencyCode: 'RWF',
    phoneCode: '250',
  },
  RS: {
    country: 'Serbia',
    countryCode: 'RS',
    currencyCode: 'RSD',
    phoneCode: '381',
  },
  TL: {
    country: 'East Timor',
    countryCode: 'TL',
    currencyCode: 'USD',
    phoneCode: '670',
  },
  RE: {
    country: 'Reunion',
    countryCode: 'RE',
    currencyCode: 'EUR',
    phoneCode: '262',
  },
  TM: {
    country: 'Turkmenistan',
    countryCode: 'TM',
    currencyCode: 'TMT',
    phoneCode: '993',
  },
  TJ: {
    country: 'Tajikistan',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    phoneCode: '992',
  },
  RO: {
    country: 'Romania',
    countryCode: 'RO',
    currencyCode: 'RON',
    phoneCode: '40',
  },
  TK: {
    country: 'Tokelau',
    countryCode: 'TK',
    currencyCode: 'NZD',
    phoneCode: '690',
  },
  GW: {
    country: 'Guinea-Bissau',
    countryCode: 'GW',
    currencyCode: 'XOF',
    phoneCode: '245',
  },
  GU: {
    country: 'Guam',
    countryCode: 'GU',
    currencyCode: 'USD',
    phoneCode: '1-671',
  },
  GT: {
    country: 'Guatemala',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    phoneCode: '502',
  },
  GS: {
    country: 'South Georgia and the South Sandwich Islands',
    countryCode: 'GS',
    currencyCode: 'GBP',
    phoneCode: '',
  },
  GR: {
    country: 'Greece',
    countryCode: 'GR',
    currencyCode: 'EUR',
    phoneCode: '30',
  },
  GQ: {
    country: 'Equatorial Guinea',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    phoneCode: '240',
  },
  GP: {
    country: 'Guadeloupe',
    countryCode: 'GP',
    currencyCode: 'EUR',
    phoneCode: '590',
  },
  JP: {
    country: 'Japan',
    countryCode: 'JP',
    currencyCode: 'JPY',
    phoneCode: '81',
  },
  GY: {
    country: 'Guyana',
    countryCode: 'GY',
    currencyCode: 'GYD',
    phoneCode: '592',
  },
  GG: {
    country: 'Guernsey',
    countryCode: 'GG',
    currencyCode: 'GBP',
    phoneCode: '44-1481',
  },
  GF: {
    country: 'French Guiana',
    countryCode: 'GF',
    currencyCode: 'EUR',
    phoneCode: '594',
  },
  GE: {
    country: 'Georgia',
    countryCode: 'GE',
    currencyCode: 'GEL',
    phoneCode: '995',
  },
  GD: {
    country: 'Grenada',
    countryCode: 'GD',
    currencyCode: 'XCD',
    phoneCode: '1-473',
  },
  GB: {
    country: 'United Kingdom',
    countryCode: 'GB',
    currencyCode: 'GBP',
    phoneCode: '44',
  },
  GA: {
    country: 'Gabon',
    countryCode: 'GA',
    currencyCode: 'XAF',
    phoneCode: '241',
  },
  SV: {
    country: 'El Salvador',
    countryCode: 'SV',
    currencyCode: 'USD',
    phoneCode: '503',
  },
  GN: {
    country: 'Guinea',
    countryCode: 'GN',
    currencyCode: 'GNF',
    phoneCode: '224',
  },
  GM: {
    country: 'Gambia',
    countryCode: 'GM',
    currencyCode: 'GMD',
    phoneCode: '220',
  },
  GL: {
    country: 'Greenland',
    countryCode: 'GL',
    currencyCode: 'DKK',
    phoneCode: '299',
  },
  GI: {
    country: 'Gibraltar',
    countryCode: 'GI',
    currencyCode: 'GIP',
    phoneCode: '350',
  },
  GH: {
    country: 'Ghana',
    countryCode: 'GH',
    currencyCode: 'GHS',
    phoneCode: '233',
  },
  OM: {
    country: 'Oman',
    countryCode: 'OM',
    currencyCode: 'OMR',
    phoneCode: '968',
  },
  TN: {
    country: 'Tunisia',
    countryCode: 'TN',
    currencyCode: 'TND',
    phoneCode: '216',
  },
  JO: {
    country: 'Jordan',
    countryCode: 'JO',
    currencyCode: 'JOD',
    phoneCode: '962',
  },
  HR: {
    country: 'Croatia',
    countryCode: 'HR',
    currencyCode: 'HRK',
    phoneCode: '385',
  },
  HT: {
    country: 'Haiti',
    countryCode: 'HT',
    currencyCode: 'HTG',
    phoneCode: '509',
  },
  HU: {
    country: 'Hungary',
    countryCode: 'HU',
    currencyCode: 'HUF',
    phoneCode: '36',
  },
  HK: {
    country: 'Hong Kong',
    countryCode: 'HK',
    currencyCode: 'HKD',
    phoneCode: '852',
  },
  HN: {
    country: 'Honduras',
    countryCode: 'HN',
    currencyCode: 'HNL',
    phoneCode: '504',
  },
  HM: {
    country: 'Heard Island and McDonald Islands',
    countryCode: 'HM',
    currencyCode: 'AUD',
    phoneCode: ' ',
  },
  VE: {
    country: 'Venezuela',
    countryCode: 'VE',
    currencyCode: 'VEF',
    phoneCode: '58',
  },
  PR: {
    country: 'Puerto Rico',
    countryCode: 'PR',
    currencyCode: 'USD',
    phoneCode: '1-787 and 1-939',
  },
  PS: {
    country: 'Palestinian Territory',
    countryCode: 'PS',
    currencyCode: 'ILS',
    phoneCode: '970',
  },
  PW: {
    country: 'Palau',
    countryCode: 'PW',
    currencyCode: 'USD',
    phoneCode: '680',
  },
  PT: {
    country: 'Portugal',
    countryCode: 'PT',
    currencyCode: 'EUR',
    phoneCode: '351',
  },
  SJ: {
    country: 'Svalbard and Jan Mayen',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    phoneCode: '47',
  },
  PY: {
    country: 'Paraguay',
    countryCode: 'PY',
    currencyCode: 'PYG',
    phoneCode: '595',
  },
  IQ: {
    country: 'Iraq',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    phoneCode: '964',
  },
  PA: {
    country: 'Panama',
    countryCode: 'PA',
    currencyCode: 'PAB',
    phoneCode: '507',
  },
  PF: {
    country: 'French Polynesia',
    countryCode: 'PF',
    currencyCode: 'XPF',
    phoneCode: '689',
  },
  PG: {
    country: 'Papua New Guinea',
    countryCode: 'PG',
    currencyCode: 'PGK',
    phoneCode: '675',
  },
  PE: {
    country: 'Peru',
    countryCode: 'PE',
    currencyCode: 'PEN',
    phoneCode: '51',
  },
  PK: {
    country: 'Pakistan',
    countryCode: 'PK',
    currencyCode: 'PKR',
    phoneCode: '92',
  },
  PH: {
    country: 'Philippines',
    countryCode: 'PH',
    currencyCode: 'PHP',
    phoneCode: '63',
  },
  PN: {
    country: 'Pitcairn',
    countryCode: 'PN',
    currencyCode: 'NZD',
    phoneCode: '870',
  },
  PL: {
    country: 'Poland',
    countryCode: 'PL',
    currencyCode: 'PLN',
    phoneCode: '48',
  },
  PM: {
    country: 'Saint Pierre and Miquelon',
    countryCode: 'PM',
    currencyCode: 'EUR',
    phoneCode: '508',
  },
  ZM: {
    country: 'Zambia',
    countryCode: 'ZM',
    currencyCode: 'ZMK',
    phoneCode: '260',
  },
  EH: {
    country: 'Western Sahara',
    countryCode: 'EH',
    currencyCode: 'MAD',
    phoneCode: '212',
  },
  EE: {
    country: 'Estonia',
    countryCode: 'EE',
    currencyCode: 'EUR',
    phoneCode: '372',
  },
  EG: {
    country: 'Egypt',
    countryCode: 'EG',
    currencyCode: 'EGP',
    phoneCode: '20',
  },
  ZA: {
    country: 'South Africa',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    phoneCode: '27',
  },
  EC: {
    country: 'Ecuador',
    countryCode: 'EC',
    currencyCode: 'USD',
    phoneCode: '593',
  },
  IT: {
    country: 'Italy',
    countryCode: 'IT',
    currencyCode: 'EUR',
    phoneCode: '39',
  },
  VN: {
    country: 'Vietnam',
    countryCode: 'VN',
    currencyCode: 'VND',
    phoneCode: '84',
  },
  SB: {
    country: 'Solomon Islands',
    countryCode: 'SB',
    currencyCode: 'SBD',
    phoneCode: '677',
  },
  ET: {
    country: 'Ethiopia',
    countryCode: 'ET',
    currencyCode: 'ETB',
    phoneCode: '251',
  },
  SO: {
    country: 'Somalia',
    countryCode: 'SO',
    currencyCode: 'SOS',
    phoneCode: '252',
  },
  ZW: {
    country: 'Zimbabwe',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    phoneCode: '263',
  },
  SA: {
    country: 'Saudi Arabia',
    countryCode: 'SA',
    currencyCode: 'SAR',
    phoneCode: '966',
  },
  ES: {
    country: 'Spain',
    countryCode: 'ES',
    currencyCode: 'EUR',
    phoneCode: '34',
  },
  ER: {
    country: 'Eritrea',
    countryCode: 'ER',
    currencyCode: 'ERN',
    phoneCode: '291',
  },
  ME: {
    country: 'Montenegro',
    countryCode: 'ME',
    currencyCode: 'EUR',
    phoneCode: '382',
  },
  MD: {
    country: 'Moldova',
    countryCode: 'MD',
    currencyCode: 'MDL',
    phoneCode: '373',
  },
  MG: {
    country: 'Madagascar',
    countryCode: 'MG',
    currencyCode: 'MGA',
    phoneCode: '261',
  },
  MF: {
    country: 'Saint Martin',
    countryCode: 'MF',
    currencyCode: 'EUR',
    phoneCode: '590',
  },
  MA: {
    country: 'Morocco',
    countryCode: 'MA',
    currencyCode: 'MAD',
    phoneCode: '212',
  },
  MC: {
    country: 'Monaco',
    countryCode: 'MC',
    currencyCode: 'EUR',
    phoneCode: '377',
  },
  UZ: {
    country: 'Uzbekistan',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    phoneCode: '998',
  },
  MM: {
    country: 'Myanmar',
    countryCode: 'MM',
    currencyCode: 'MMK',
    phoneCode: '95',
  },
  ML: {
    country: 'Mali',
    countryCode: 'ML',
    currencyCode: 'XOF',
    phoneCode: '223',
  },
  MO: {
    country: 'Macao',
    countryCode: 'MO',
    currencyCode: 'MOP',
    phoneCode: '853',
  },
  MN: {
    country: 'Mongolia',
    countryCode: 'MN',
    currencyCode: 'MNT',
    phoneCode: '976',
  },
  MH: {
    country: 'Marshall Islands',
    countryCode: 'MH',
    currencyCode: 'USD',
    phoneCode: '692',
  },
  MK: {
    country: 'Macedonia',
    countryCode: 'MK',
    currencyCode: 'MKD',
    phoneCode: '389',
  },
  MU: {
    country: 'Mauritius',
    countryCode: 'MU',
    currencyCode: 'MUR',
    phoneCode: '230',
  },
  MT: {
    country: 'Malta',
    countryCode: 'MT',
    currencyCode: 'EUR',
    phoneCode: '356',
  },
  MW: {
    country: 'Malawi',
    countryCode: 'MW',
    currencyCode: 'MWK',
    phoneCode: '265',
  },
  MV: {
    country: 'Maldives',
    countryCode: 'MV',
    currencyCode: 'MVR',
    phoneCode: '960',
  },
  MQ: {
    country: 'Martinique',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    phoneCode: '596',
  },
  MP: {
    country: 'Northern Mariana Islands',
    countryCode: 'MP',
    currencyCode: 'USD',
    phoneCode: '1-670',
  },
  MS: {
    country: 'Montserrat',
    countryCode: 'MS',
    currencyCode: 'XCD',
    phoneCode: '1-664',
  },
  MR: {
    country: 'Mauritania',
    countryCode: 'MR',
    currencyCode: 'MRO',
    phoneCode: '222',
  },
  IM: {
    country: 'Isle of Man',
    countryCode: 'IM',
    currencyCode: 'GBP',
    phoneCode: '44-1624',
  },
  UG: {
    country: 'Uganda',
    countryCode: 'UG',
    currencyCode: 'UGX',
    phoneCode: '256',
  },
  TZ: {
    country: 'Tanzania',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    phoneCode: '255',
  },
  MY: {
    country: 'Malaysia',
    countryCode: 'MY',
    currencyCode: 'MYR',
    phoneCode: '60',
  },
  MX: {
    country: 'Mexico',
    countryCode: 'MX',
    currencyCode: 'MXN',
    phoneCode: '52',
  },
  IL: {
    country: 'Israel',
    countryCode: 'IL',
    currencyCode: 'ILS',
    phoneCode: '972',
  },
  FR: {
    country: 'France',
    countryCode: 'FR',
    currencyCode: 'EUR',
    phoneCode: '33',
  },
  IO: {
    country: 'British Indian Ocean Territory',
    countryCode: 'IO',
    currencyCode: 'USD',
    phoneCode: '246',
  },
  SH: {
    country: 'Saint Helena',
    countryCode: 'SH',
    currencyCode: 'SHP',
    phoneCode: '290',
  },
  FI: {
    country: 'Finland',
    countryCode: 'FI',
    currencyCode: 'EUR',
    phoneCode: '358',
  },
  FJ: {
    country: 'Fiji',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    phoneCode: '679',
  },
  FK: {
    country: 'Falkland Islands',
    countryCode: 'FK',
    currencyCode: 'FKP',
    phoneCode: '500',
  },
  FM: {
    country: 'Micronesia',
    countryCode: 'FM',
    currencyCode: 'USD',
    phoneCode: '691',
  },
  FO: {
    country: 'Faroe Islands',
    countryCode: 'FO',
    currencyCode: 'DKK',
    phoneCode: '298',
  },
  NI: {
    country: 'Nicaragua',
    countryCode: 'NI',
    currencyCode: 'NIO',
    phoneCode: '505',
  },
  NL: {
    country: 'Netherlands',
    countryCode: 'NL',
    currencyCode: 'EUR',
    phoneCode: '31',
  },
  NO: {
    country: 'Norway',
    countryCode: 'NO',
    currencyCode: 'NOK',
    phoneCode: '47',
  },
  NA: {
    country: 'Namibia',
    countryCode: 'NA',
    currencyCode: 'NAD',
    phoneCode: '264',
  },
  VU: {
    country: 'Vanuatu',
    countryCode: 'VU',
    currencyCode: 'VUV',
    phoneCode: '678',
  },
  NC: {
    country: 'New Caledonia',
    countryCode: 'NC',
    currencyCode: 'XPF',
    phoneCode: '687',
  },
  NE: {
    country: 'Niger',
    countryCode: 'NE',
    currencyCode: 'XOF',
    phoneCode: '227',
  },
  NF: {
    country: 'Norfolk Island',
    countryCode: 'NF',
    currencyCode: 'AUD',
    phoneCode: '672',
  },
  NG: {
    country: 'Nigeria',
    countryCode: 'NG',
    currencyCode: 'NGN',
    phoneCode: '234',
  },
  NZ: {
    country: 'New Zealand',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    phoneCode: '64',
  },
  NP: {
    country: 'Nepal',
    countryCode: 'NP',
    currencyCode: 'NPR',
    phoneCode: '977',
  },
  NR: {
    country: 'Nauru',
    countryCode: 'NR',
    currencyCode: 'AUD',
    phoneCode: '674',
  },
  NU: {
    country: 'Niue',
    countryCode: 'NU',
    currencyCode: 'NZD',
    phoneCode: '683',
  },
  CK: {
    country: 'Cook Islands',
    countryCode: 'CK',
    currencyCode: 'NZD',
    phoneCode: '682',
  },
  XK: {
    country: 'Kosovo',
    countryCode: 'XK',
    currencyCode: 'EUR',
    phoneCode: '',
  },
  CI: {
    country: 'Ivory Coast',
    countryCode: 'CI',
    currencyCode: 'XOF',
    phoneCode: '225',
  },
  CH: {
    country: 'Switzerland',
    countryCode: 'CH',
    currencyCode: 'CHF',
    phoneCode: '41',
  },
  CO: {
    country: 'Colombia',
    countryCode: 'CO',
    currencyCode: 'COP',
    phoneCode: '57',
  },
  CN: {
    country: 'China',
    countryCode: 'CN',
    currencyCode: 'CNY',
    phoneCode: '86',
  },
  CM: {
    country: 'Cameroon',
    countryCode: 'CM',
    currencyCode: 'XAF',
    phoneCode: '237',
  },
  CL: {
    country: 'Chile',
    countryCode: 'CL',
    currencyCode: 'CLP',
    phoneCode: '56',
  },
  CC: {
    country: 'Cocos Islands',
    countryCode: 'CC',
    currencyCode: 'AUD',
    phoneCode: '61',
  },
  CA: {
    country: 'Canada',
    countryCode: 'CA',
    currencyCode: 'CAD',
    phoneCode: '1',
  },
  CG: {
    country: 'Republic of the Congo',
    countryCode: 'CG',
    currencyCode: 'XAF',
    phoneCode: '242',
  },
  CF: {
    country: 'Central African Republic',
    countryCode: 'CF',
    currencyCode: 'XAF',
    phoneCode: '236',
  },
  CD: {
    country: 'Democratic Republic of the Congo',
    countryCode: 'CD',
    currencyCode: 'CDF',
    phoneCode: '243',
  },
  CZ: {
    country: 'Czech Republic',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    phoneCode: '420',
  },
  CY: {
    country: 'Cyprus',
    countryCode: 'CY',
    currencyCode: 'EUR',
    phoneCode: '357',
  },
  CX: {
    country: 'Christmas Island',
    countryCode: 'CX',
    currencyCode: 'AUD',
    phoneCode: '61',
  },
  CR: {
    country: 'Costa Rica',
    countryCode: 'CR',
    currencyCode: 'CRC',
    phoneCode: '506',
  },
  CW: {
    country: 'Curacao',
    countryCode: 'CW',
    currencyCode: 'ANG',
    phoneCode: '599',
  },
  CV: {
    country: 'Cape Verde',
    countryCode: 'CV',
    currencyCode: 'CVE',
    phoneCode: '238',
  },
  CU: {
    country: 'Cuba',
    countryCode: 'CU',
    currencyCode: 'CUP',
    phoneCode: '53',
  },
  SZ: {
    country: 'Swaziland',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    phoneCode: '268',
  },
  SY: {
    country: 'Syria',
    countryCode: 'SY',
    currencyCode: 'SYP',
    phoneCode: '963',
  },
  SX: {
    country: 'Sint Maarten',
    countryCode: 'SX',
    currencyCode: 'ANG',
    phoneCode: '599',
  },
  KG: {
    country: 'Kyrgyzstan',
    countryCode: 'KG',
    currencyCode: 'KGS',
    phoneCode: '996',
  },
  KE: {
    country: 'Kenya',
    countryCode: 'KE',
    currencyCode: 'KES',
    phoneCode: '254',
  },
  SS: {
    country: 'South Sudan',
    countryCode: 'SS',
    currencyCode: 'SSP',
    phoneCode: '211',
  },
  SR: {
    country: 'Suriname',
    countryCode: 'SR',
    currencyCode: 'SRD',
    phoneCode: '597',
  },
  KI: {
    country: 'Kiribati',
    countryCode: 'KI',
    currencyCode: 'AUD',
    phoneCode: '686',
  },
  KH: {
    country: 'Cambodia',
    countryCode: 'KH',
    currencyCode: 'KHR',
    phoneCode: '855',
  },
  KN: {
    country: 'Saint Kitts and Nevis',
    countryCode: 'KN',
    currencyCode: 'XCD',
    phoneCode: '1-869',
  },
  KM: {
    country: 'Comoros',
    countryCode: 'KM',
    currencyCode: 'KMF',
    phoneCode: '269',
  },
  ST: {
    country: 'Sao Tome and Principe',
    countryCode: 'ST',
    currencyCode: 'STD',
    phoneCode: '239',
  },
  SK: {
    country: 'Slovakia',
    countryCode: 'SK',
    currencyCode: 'EUR',
    phoneCode: '421',
  },
  KR: {
    country: 'South Korea',
    countryCode: 'KR',
    currencyCode: 'KRW',
    phoneCode: '82',
  },
  SI: {
    country: 'Slovenia',
    countryCode: 'SI',
    currencyCode: 'EUR',
    phoneCode: '386',
  },
  KP: {
    country: 'North Korea',
    countryCode: 'KP',
    currencyCode: 'KPW',
    phoneCode: '850',
  },
  KW: {
    country: 'Kuwait',
    countryCode: 'KW',
    currencyCode: 'KWD',
    phoneCode: '965',
  },
  SN: {
    country: 'Senegal',
    countryCode: 'SN',
    currencyCode: 'XOF',
    phoneCode: '221',
  },
  SM: {
    country: 'San Marino',
    countryCode: 'SM',
    currencyCode: 'EUR',
    phoneCode: '378',
  },
  SL: {
    country: 'Sierra Leone',
    countryCode: 'SL',
    currencyCode: 'SLL',
    phoneCode: '232',
  },
  SC: {
    country: 'Seychelles',
    countryCode: 'SC',
    currencyCode: 'SCR',
    phoneCode: '248',
  },
  KZ: {
    country: 'Kazakhstan',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    phoneCode: '7',
  },
  KY: {
    country: 'Cayman Islands',
    countryCode: 'KY',
    currencyCode: 'KYD',
    phoneCode: '1-345',
  },
  SG: {
    country: 'Singapore',
    countryCode: 'SG',
    currencyCode: 'SGD',
    phoneCode: '65',
  },
  SE: {
    country: 'Sweden',
    countryCode: 'SE',
    currencyCode: 'SEK',
    phoneCode: '46',
  },
  SD: {
    country: 'Sudan',
    countryCode: 'SD',
    currencyCode: 'SDG',
    phoneCode: '249',
  },
  DO: {
    country: 'Dominican Republic',
    countryCode: 'DO',
    currencyCode: 'DOP',
    phoneCode: '1-809 and 1-829',
  },
  DM: {
    country: 'Dominica',
    countryCode: 'DM',
    currencyCode: 'XCD',
    phoneCode: '1-767',
  },
  DJ: {
    country: 'Djibouti',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    phoneCode: '253',
  },
  DK: {
    country: 'Denmark',
    countryCode: 'DK',
    currencyCode: 'DKK',
    phoneCode: '45',
  },
  VG: {
    country: 'British Virgin Islands',
    countryCode: 'VG',
    currencyCode: 'USD',
    phoneCode: '1-284',
  },
  DE: {
    country: 'Germany',
    countryCode: 'DE',
    currencyCode: 'EUR',
    phoneCode: '49',
  },
  YE: {
    country: 'Yemen',
    countryCode: 'YE',
    currencyCode: 'YER',
    phoneCode: '967',
  },
  DZ: {
    country: 'Algeria',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    phoneCode: '213',
  },
  US: {
    country: 'United States',
    countryCode: 'US',
    currencyCode: 'USD',
    phoneCode: '1',
  },
  UY: {
    country: 'Uruguay',
    countryCode: 'UY',
    currencyCode: 'UYU',
    phoneCode: '598',
  },
  YT: {
    country: 'Mayotte',
    countryCode: 'YT',
    currencyCode: 'EUR',
    phoneCode: '262',
  },
  UM: {
    country: 'United States Minor Outlying Islands',
    countryCode: 'UM',
    currencyCode: 'USD',
    phoneCode: '1',
  },
  LB: {
    country: 'Lebanon',
    countryCode: 'LB',
    currencyCode: 'LBP',
    phoneCode: '961',
  },
  LC: {
    country: 'Saint Lucia',
    countryCode: 'LC',
    currencyCode: 'XCD',
    phoneCode: '1-758',
  },
  LA: {
    country: 'Laos',
    countryCode: 'LA',
    currencyCode: 'LAK',
    phoneCode: '856',
  },
  TV: {
    country: 'Tuvalu',
    countryCode: 'TV',
    currencyCode: 'AUD',
    phoneCode: '688',
  },
  TW: {
    country: 'Taiwan',
    countryCode: 'TW',
    currencyCode: 'TWD',
    phoneCode: '886',
  },
  TT: {
    country: 'Trinidad and Tobago',
    countryCode: 'TT',
    currencyCode: 'TTD',
    phoneCode: '1-868',
  },
  TR: {
    country: 'Turkey',
    countryCode: 'TR',
    currencyCode: 'TRY',
    phoneCode: '90',
  },
  LK: {
    country: 'Sri Lanka',
    countryCode: 'LK',
    currencyCode: 'LKR',
    phoneCode: '94',
  },
  LI: {
    country: 'Liechtenstein',
    countryCode: 'LI',
    currencyCode: 'CHF',
    phoneCode: '423',
  },
  LV: {
    country: 'Latvia',
    countryCode: 'LV',
    currencyCode: 'EUR',
    phoneCode: '371',
  },
  TO: {
    country: 'Tonga',
    countryCode: 'TO',
    currencyCode: 'TOP',
    phoneCode: '676',
  },
  LT: {
    country: 'Lithuania',
    countryCode: 'LT',
    currencyCode: 'LTL',
    phoneCode: '370',
  },
  LU: {
    country: 'Luxembourg',
    countryCode: 'LU',
    currencyCode: 'EUR',
    phoneCode: '352',
  },
  LR: {
    country: 'Liberia',
    countryCode: 'LR',
    currencyCode: 'LRD',
    phoneCode: '231',
  },
  LS: {
    country: 'Lesotho',
    countryCode: 'LS',
    currencyCode: 'LSL',
    phoneCode: '266',
  },
  TH: {
    country: 'Thailand',
    countryCode: 'TH',
    currencyCode: 'THB',
    phoneCode: '66',
  },
  TF: {
    country: 'French Southern Territories',
    countryCode: 'TF',
    currencyCode: 'EUR',
    phoneCode: '',
  },
  TG: {
    country: 'Togo',
    countryCode: 'TG',
    currencyCode: 'XOF',
    phoneCode: '228',
  },
  TD: {
    country: 'Chad',
    countryCode: 'TD',
    currencyCode: 'XAF',
    phoneCode: '235',
  },
  TC: {
    country: 'Turks and Caicos Islands',
    countryCode: 'TC',
    currencyCode: 'USD',
    phoneCode: '1-649',
  },
  LY: {
    country: 'Libya',
    countryCode: 'LY',
    currencyCode: 'LYD',
    phoneCode: '218',
  },
  VA: {
    country: 'Vatican',
    countryCode: 'VA',
    currencyCode: 'EUR',
    phoneCode: '379',
  },
  VC: {
    country: 'Saint Vincent and the Grenadines',
    countryCode: 'VC',
    currencyCode: 'XCD',
    phoneCode: '1-784',
  },
  AE: {
    country: 'United Arab Emirates',
    countryCode: 'AE',
    currencyCode: 'AED',
    phoneCode: '971',
  },
  AD: {
    country: 'Andorra',
    countryCode: 'AD',
    currencyCode: 'EUR',
    phoneCode: '376',
  },
  AG: {
    country: 'Antigua and Barbuda',
    countryCode: 'AG',
    currencyCode: 'XCD',
    phoneCode: '1-268',
  },
  AF: {
    country: 'Afghanistan',
    countryCode: 'AF',
    currencyCode: 'AFN',
    phoneCode: '93',
  },
  AI: {
    country: 'Anguilla',
    countryCode: 'AI',
    currencyCode: 'XCD',
    phoneCode: '1-264',
  },
  VI: {
    country: 'U.S. Virgin Islands',
    countryCode: 'VI',
    currencyCode: 'USD',
    phoneCode: '1-340',
  },
  IS: {
    country: 'Iceland',
    countryCode: 'IS',
    currencyCode: 'ISK',
    phoneCode: '354',
  },
  IR: {
    country: 'Iran',
    countryCode: 'IR',
    currencyCode: 'IRR',
    phoneCode: '98',
  },
  AM: {
    country: 'Armenia',
    countryCode: 'AM',
    currencyCode: 'AMD',
    phoneCode: '374',
  },
  AL: {
    country: 'Albania',
    countryCode: 'AL',
    currencyCode: 'ALL',
    phoneCode: '355',
  },
  AO: {
    country: 'Angola',
    countryCode: 'AO',
    currencyCode: 'AOA',
    phoneCode: '244',
  },
  AQ: {
    country: 'Antarctica',
    countryCode: 'AQ',
    currencyCode: '',
    phoneCode: '',
  },
  AS: {
    country: 'American Samoa',
    countryCode: 'AS',
    currencyCode: 'USD',
    phoneCode: '1-684',
  },
  AR: {
    country: 'Argentina',
    countryCode: 'AR',
    currencyCode: 'ARS',
    phoneCode: '54',
  },
  AU: {
    country: 'Australia',
    countryCode: 'AU',
    currencyCode: 'AUD',
    phoneCode: '61',
  },
  AT: {
    country: 'Austria',
    countryCode: 'AT',
    currencyCode: 'EUR',
    phoneCode: '43',
  },
  AW: {
    country: 'Aruba',
    countryCode: 'AW',
    currencyCode: 'AWG',
    phoneCode: '297',
  },
  IN: {
    country: 'India',
    countryCode: 'IN',
    currencyCode: 'INR',
    phoneCode: '91',
  },
  AX: {
    country: 'Aland Islands',
    countryCode: 'AX',
    currencyCode: 'EUR',
    phoneCode: '358-18',
  },
  AZ: {
    country: 'Azerbaijan',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    phoneCode: '994',
  },
  IE: {
    country: 'Ireland',
    countryCode: 'IE',
    currencyCode: 'EUR',
    phoneCode: '353',
  },
  ID: {
    country: 'Indonesia',
    countryCode: 'ID',
    currencyCode: 'IDR',
    phoneCode: '62',
  },
  UA: {
    country: 'Ukraine',
    countryCode: 'UA',
    currencyCode: 'UAH',
    phoneCode: '380',
  },
  QA: {
    country: 'Qatar',
    countryCode: 'QA',
    currencyCode: 'QAR',
    phoneCode: '974',
  },
  MZ: {
    country: 'Mozambique',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    phoneCode: '258',
  },
}
